export const CONTENT_WIDTH_REM = 85;
export const CONTENT_WIDTH_PX = CONTENT_WIDTH_REM * 16;

export const DEFAULT_CONFIDENCE_LEVEL = 0.9;
